import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=8adbcd0a&scoped=true&"
import script from "./HeroSlider.vue?vue&type=script&lang=js&"
export * from "./HeroSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adbcd0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kellymcnamara/git/gotconquest.com/web/app/themes/got/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8adbcd0a')) {
      api.createRecord('8adbcd0a', component.options)
    } else {
      api.reload('8adbcd0a', component.options)
    }
    module.hot.accept("./HeroSlider.vue?vue&type=template&id=8adbcd0a&scoped=true&", function () {
      api.rerender('8adbcd0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/slider/HeroSlider.vue"
export default component.exports